import { NavDataType } from "../model";

export const NavigationData: NavDataType[] = [
  {
    Label: "About",
    Section: "/about",
  },
  {
    Label: "Projects",
    Section: "/project",
  },
];
